/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var NProgress = require('nprogress');
var Backbone = require('backbone');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var GetAllEntityLookups = require('../../common/services/GetAllEntityLookups');
var GetEvent = require('../services/GetEvent');

var COCEditEventOrganizationDetailsView = require('../views/COCEditEventOrganizationDetailsView');

module.exports = function(eventId) {
  NProgress.start();
  NProgress.set(0.6);

  $.when(GetAllEntityLookups(), GetEvent(eventId))
    .done(function(lookups, event) {
      NavUtils.navigate('coc/event/' + eventId + '/edit-org');

      Scaffold.content.show(
        new COCEditEventOrganizationDetailsView({
          model: new Backbone.Model({
            organizationTypes: lookups.organizationTypes,
            entityTypes: lookups.entityTypes,
            organizationId: event.organization.id,
            contactId: event.organization.contactId,
            event: {
              eventId: event.id,
              eventTitle: event.eventTitle,
              organizationName: event.organization.name,
              organizationType: event.organization.type,
              orgVenueAddress: event.organization.fullAddress,
              orgWebsite: event.organization.website,
              orgContactName: event.organization.contactFirstName + ' ' + event.organization.contactLastName,
              orgPhone: event.organization.contactPhone,
              orgEmail: event.organization.contactEmail              
            }
          })
        })
      );
      NProgress.done();
    })
    .fail(function() {
      NProgress.done();
    });
};
